module.exports = __webpack_public_path__ + "static/media/konsepti.d5abb064.png";